/* eslint no-param-reassign: "off", no-console: "off" */
const apiclientStore = {
  state: {
    apiClients: [],
    apiClientsLoading: false,
    apiClientAdding: false,
    apiClientDeleting: false
  },
  mutations: {
    fetchApiClients(state, payload) {
      state.apiClients = payload;
    },
    addApiClient(state, payload) {
      state.apiClients.unshift(payload);
    },
    deleteApiClient(state, payload) {
      state.apiClients = state.apiClients.filter(f => f.clientId != payload);
    }
  },
  actions: {
    /*
    * API Clients
    */
    async fetchApiClients({ state, commit }) {
      try {
        state.apiClientsLoading = true;
        const res = await fetch('/v2/users/client');
        if (!res.ok) throw new Error(await res.text());

        const data = await res.json();
        commit('fetchApiClients', data);
        state.apiClientsLoading = false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async addApiClient({ state, commit }, payload) {
      try {
        state.apiClientAdding = true;
        const res = await fetch('/v2/users/client', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        if (!res.ok) throw new Error(await res.text());

        commit('addApiClient', payload);
        state.apiClientAdding = false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async deleteApiClient({ state, commit }, clientId) {
      try {
        state.apiClientDeleting = clientId;
        const res = await fetch(`/v2/users/client/${clientId}`, {
          method: 'DELETE'
        });
        if (!res.ok) throw new Error(await res.text());
        
        commit('deleteApiClient', clientId);
        state.apiClientDeleting = null;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  },
  getters: {

  }
}
export default apiclientStore;
